"use client";

import { SectionLoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { useFilterablePaginatedSectionQuery } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { SDUIFilterablePaginatedSectionPaginationRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Pagination/SDUIFilterablePaginatedSectionPaginationRenderer";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import React from "react";

export const SDUIFilterablePaginatedSectionPaginationNonRSC: React.FC<{
  filterablePaginatedSection: IFilterablePaginatedSection;
  sectionLoggingData: SectionLoggingEventParams;
}> = ({ filterablePaginatedSection, sectionLoggingData }) => {
  const { filteredComponentsData } = useFilterablePaginatedSectionQuery(
    filterablePaginatedSection
  );
  return (
    <SDUIFilterablePaginatedSectionPaginationRenderer
      paginationData={filteredComponentsData?.pagination_data}
      sectionLoggingData={sectionLoggingData}
      filterablePaginatedSection={filterablePaginatedSection}
    />
  );
};
